import React from 'react';
import { LayoutDashboardIcon, MegaphoneIcon, InboxIcon, TruckIcon, CreditCardIcon, GaugeIcon, LifeBuoyIcon, UserIcon, BrainCircuitIcon, SettingsIcon, FileCheckIcon, DumbbellIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
interface SidebarProps {
  activeTab?: string;
  onTabChange?: (tabId: string) => void;
}
export function Sidebar({
  activeTab = 'bciti',
  onTabChange
}: SidebarProps) {
  const {
    t
  } = useLanguage();
  const menuItems = [{
    id: 'dashboard',
    icon: LayoutDashboardIcon,
    label: 'Tableau de bord'
  }, {
    id: 'usager',
    icon: UserIcon,
    label: 'Usagers'
  }, {
    id: 'bciti-id',
    icon: CreditCardIcon,
    label: 'ID'
  }, {
    id: 'bciti',
    icon: MegaphoneIcon,
    label: 'Communications'
  }, {
    id: 'requetes',
    icon: InboxIcon,
    label: 'Requêtes'
  }, {
    id: 'permis',
    icon: FileCheckIcon,
    label: 'Permis'
  }, {
    id: 'loisirs',
    icon: DumbbellIcon,
    label: 'Loisirs'
  }, {
    id: 'collectes',
    icon: TruckIcon,
    label: 'Collectes'
  }, {
    id: 'compteurs',
    icon: GaugeIcon,
    label: 'Compteurs'
  }, {
    id: 'atna',
    icon: BrainCircuitIcon,
    label: 'ATNA AI'
  }, {
    id: 'settings',
    icon: SettingsIcon,
    label: 'Paramètres'
  }];
  return <aside className="w-64 bg-white border-r border-slate-200 hidden lg:flex flex-col h-full" data-id="element-5826" data-mp="24oc15jo6zgag">
      <nav className="flex-1 py-6 px-4 space-y-1.5" data-id="element-5827" data-mp="29n5dh8rqt191">
        {menuItems.map(item => {
        const Icon = item.icon;
        const isActive = activeTab === item.id;
        return <button key={item.id} onClick={() => onTabChange?.(item.id)} className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${isActive ? 'bg-[#0F172A] text-white shadow-sm' : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900'}`} data-id="element-5828" data-mp="20qo3w9z11bfe">
              <Icon className={`w-5 h-5 ${isActive ? 'text-[#4F46E5]' : 'text-slate-400'}`} data-id="element-5829" data-mp="2lyz7pe16g2ph" />
              {item.label}
            </button>;
      })}
      </nav>

      <div className="p-4 border-t border-slate-200" data-id="element-5830" data-mp="2d7yv6kt833ec">
        <div className="bg-slate-50 p-4 rounded-lg border border-slate-200" data-id="element-5831" data-mp="2d52wuvdgqcpd">
          <div className="flex items-center gap-2 mb-2" data-id="element-5832" data-mp="289nky8z0mqvl">
            <LifeBuoyIcon className="w-4 h-4 text-slate-500" data-id="element-5833" data-mp="238gce7p1tnnv" />
            <p className="text-xs font-semibold text-slate-600 uppercase tracking-wider" data-id="element-5834" data-mp="23b2hm0ogvr2x">
              {t('Support', 'Support')}
            </p>
          </div>
          <p className="text-xs text-slate-500 mb-3 leading-relaxed" data-id="element-5835" data-mp="1u9mkuvqkrnh6">
            {t('Besoin d’aide avec le système de géorepérage ?', 'Need help with the geofencing system?')}
          </p>
          <button className="text-sm text-[#4F46E5] font-medium hover:text-[#4338CA] transition-colors" data-id="element-5836" data-mp="3ok7z5y9om98g">
            {t('Contacter le support', 'Contact support')}
          </button>
        </div>
      </div>
    </aside>;
}